import { PublicClientApplication } from '@azure/msal-browser'

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: import.meta.env.VITE_AUTH_APP_ID,
    authority: import.meta.env.VITE_AUTHORITY,
    redirectUri: import.meta.env.VITE_AUTH_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
})

export const loginRequest = {
  scopes: ['user.read', 'offline_access', 'openid', 'email', 'profile'],
}
